export enum noPermissionTags {
  noPermission = 'Parece que no tienes permisos para ver esta página',
  goHome = 'Ir a Inicio'
}
